/* ================================================================
   Lithios PDP Redesign — Interactivity
   ================================================================ */
(function () {
  'use strict';

  /* ── HOWIE25 promo price (visual only) ──────────────────────────
     When [data-pdp-hero] carries data-promo-price, the storefront shows
     the hard-coded post-discount price (e.g. 41.24) instead of the raw
     Shopify variant price. The 25% HOWIE25 discount is applied at checkout
     by Shopify's automatic discount. NaN when no promo is active. */
  var pdpPromoEl = document.querySelector('[data-pdp-hero]');
  var pdpPromoPrice = pdpPromoEl ? parseFloat(pdpPromoEl.getAttribute('data-promo-price')) : NaN;

  /* ── Nav scroll effect ──────────────────────────────────────── */
  var nav = document.querySelector('.pdp-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('is-scrolled', window.scrollY > 30);
    }, { passive: true });
  }

  /* ── Product image load animation ───────────────────────────── */
  document.querySelectorAll('.pdp-hero__product-img, [data-hero-main-img]').forEach(function (img) {
    img.addEventListener('load', function () { img.classList.add('is-loaded'); });
    if (img.complete && img.naturalWidth) img.classList.add('is-loaded');
  });

  /* ── Flavor / Variant switching ─────────────────────────────── */
  var heroSection = document.querySelector('[data-pdp-hero]');
  if (heroSection) {
    var productData = JSON.parse(heroSection.getAttribute('data-product-json') || '{}');
    var variants = productData.variants || [];
    var currentVariantId = productData.initial_variant_id;
    var initialVariant = variants.find(function (v) { return v.id === currentVariantId; });

    function findVariantByOption(optionValue) {
      return variants.find(function (v) {
        return v.options.some(function (o) {
          return o.toLowerCase() === optionValue.toLowerCase();
        });
      });
    }

    function updateVariant(variant) {
      if (!variant) return;
      currentVariantId = variant.id;

      // Update price display
      var priceEl = heroSection.querySelector('[data-onetime-price]');
      if (priceEl) priceEl.textContent = '$' + (isNaN(pdpPromoPrice) ? (variant.price / 100) : pdpPromoPrice).toFixed(2);

      // Update image gallery — show only images for this variant
      updateImageGallery(variant);

      // Update subtitle
      var subtitle = heroSection.querySelector('.pdp-hero__subtitle');
      if (subtitle) subtitle.textContent = variant.title;

      // Update URL without reload
      var url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      // Update sticky bar price
      updateStickyPrice(variant);

      // Enable/disable ATC based on availability
      updateATCAvailability(variant.available);

      // Update ATC button price (only runs if available)
      updateATCPrice();
    }

    function updateImageGallery(variant) {
      var thumbs = heroSection.querySelectorAll('[data-thumb-variant-ids]');
      var firstMatchSrc = null;
      var firstMatchAlt = null;

      thumbs.forEach(function (thumb) {
        var ids = thumb.getAttribute('data-thumb-variant-ids');
        var isShared = ids === '';
        var matchesVariant = isShared || ids.split(',').indexOf(String(variant.id)) !== -1;

        thumb.style.display = matchesVariant ? '' : 'none';
        thumb.classList.toggle('is-variant-match', matchesVariant);
        thumb.classList.remove('is-active');

        if (matchesVariant && !firstMatchSrc) {
          firstMatchSrc = thumb.getAttribute('data-thumb-src');
          firstMatchAlt = thumb.getAttribute('data-thumb-alt');
          thumb.classList.add('is-active');
        }
      });

      // Update main image to first matching thumbnail
      if (firstMatchSrc) {
        var mainImg = heroSection.querySelector('[data-hero-main-img]');
        if (mainImg) {
          mainImg.classList.remove('is-loaded');
          mainImg.src = firstMatchSrc;
          mainImg.alt = firstMatchAlt || variant.title;
        }
      }
    }

    // Thumbnail click → update main image
    heroSection.querySelectorAll('[data-thumb-variant-ids]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-thumb-src');
        var alt = thumb.getAttribute('data-thumb-alt');
        var mainImg = heroSection.querySelector('[data-hero-main-img]');
        if (mainImg && src) {
          mainImg.classList.remove('is-loaded');
          mainImg.src = src;
          mainImg.alt = alt || '';
        }
        heroSection.querySelectorAll('[data-thumb-variant-ids]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    // Hero flavor buttons
    heroSection.querySelectorAll('[data-flavor-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        heroSection.querySelectorAll('[data-flavor-btn]').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var variant = findVariantByOption(btn.getAttribute('data-flavor-btn'));
        if (variant) updateVariant(variant);

        // Sync sticky bar flavor buttons
        document.querySelectorAll('[data-sticky-flavor]').forEach(function (sf) {
          sf.classList.toggle('is-selected', sf.getAttribute('data-sticky-flavor') === btn.getAttribute('data-flavor-btn'));
        });
      });
    });

    // Sticky bar flavor buttons
    document.querySelectorAll('[data-sticky-flavor]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('[data-sticky-flavor]').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var variant = findVariantByOption(btn.getAttribute('data-sticky-flavor'));
        if (variant) updateVariant(variant);

        // Sync hero flavor buttons
        heroSection.querySelectorAll('[data-flavor-btn]').forEach(function (hf) {
          hf.classList.toggle('is-selected', hf.getAttribute('data-flavor-btn').toLowerCase() === btn.getAttribute('data-sticky-flavor').toLowerCase());
        });
      });
    });

    if (initialVariant) updateATCAvailability(initialVariant.available);
  }

  /* ── Purchase plan toggle ───────────────────────────────────── */
  var planButtons = document.querySelectorAll('[data-plan-btn]');
  planButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      planButtons.forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      updateATCPrice();
    });
  });

  /* ── Quantity selector ──────────────────────────────────────── */
  var qtyDisplay = document.querySelector('[data-qty-display]');
  var qtyMinus = document.querySelector('[data-qty-minus]');
  var qtyPlus = document.querySelector('[data-qty-plus]');
  var currentQty = 1;

  if (qtyMinus && qtyPlus && qtyDisplay) {
    qtyMinus.addEventListener('click', function () {
      if (currentQty > 1) { currentQty--; qtyDisplay.textContent = currentQty; updateATCPrice(); }
    });
    qtyPlus.addEventListener('click', function () {
      currentQty++; qtyDisplay.textContent = currentQty; updateATCPrice();
    });
  }

  /* ── ATC availability ───────────────────────────────────────── */
  function updateATCAvailability(available) {
    document.querySelectorAll('[data-pdp-atc]').forEach(function (btn) {
      btn.disabled = !available;
      if (!available) {
        btn.textContent = 'SOLD OUT';
      } else if (!btn.querySelector('[data-atc-price]')) {
        var span = document.createElement('span');
        span.setAttribute('data-atc-price', '');
        btn.textContent = 'ADD TO CART \xB7 ';
        btn.appendChild(span);
        updateATCPrice();
      }
    });
  }

  /* ── Price helpers ──────────────────────────────────────────── */
  function getSelectedPrice() {
    var activePlan = document.querySelector('[data-plan-btn].is-selected');
    if (activePlan) return parseFloat(activePlan.getAttribute('data-plan-price'));
    return parseFloat(document.querySelector('[data-plan-btn]').getAttribute('data-plan-price'));
  }

  function updateATCPrice() {
    var price = getSelectedPrice();
    var total = (price * currentQty).toFixed(2);
    document.querySelectorAll('[data-atc-price]').forEach(function (el) {
      el.textContent = '$' + total;
    });
  }

  function updateStickyPrice(variant) {
    var stickyPrice = document.querySelector('.pdp-sticky__price');
    if (stickyPrice && variant) {
      var activePlan = document.querySelector('[data-plan-btn].is-selected');
      var planType = activePlan ? activePlan.getAttribute('data-plan-btn') : 'once';
      var price = planType === 'sub'
        ? parseFloat(activePlan.getAttribute('data-plan-price')).toFixed(2)
        : (isNaN(pdpPromoPrice) ? (variant.price / 100) : pdpPromoPrice).toFixed(2);
      stickyPrice.textContent = '$' + price + (planType === 'sub' ? '/mo' : '');
    }
  }

  /* ── Add to Cart ────────────────────────────────────────────── */
  function addToCart() {
    if (!currentVariantId) { console.warn('ATC: no variant selected'); return; }
    var activePlan = document.querySelector('[data-plan-btn].is-selected');
    var formData = { id: currentVariantId, quantity: currentQty };

    if (activePlan && activePlan.getAttribute('data-selling-plan')) {
      formData.selling_plan = parseInt(activePlan.getAttribute('data-selling-plan'));
    }

    console.log('ATC request:', formData);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(formData)
    })
    .then(function (res) {
      return res.json().then(function (data) {
        console.log('ATC response (' + res.status + '):', data);
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        return data;
      });
    })
    .then(function () {
      showCartToast();
      updateCartCount();
    })
    .catch(function (err) {
      console.error('Add to cart failed:', err);
      var atcBtns = document.querySelectorAll('[data-pdp-atc]');
      atcBtns.forEach(function (b) {
        b.classList.add('is-error');
        setTimeout(function () { b.classList.remove('is-error'); }, 2000);
      });
    });
  }

  document.querySelectorAll('[data-pdp-atc]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      addToCart();
    });
  });

  /* ── Cart toast ─────────────────────────────────────────────── */
  function showCartToast() {
    var toast = document.querySelector('.pdp-cart-toast');
    if (!toast) return;
    toast.classList.add('is-visible');
    setTimeout(function () { toast.classList.remove('is-visible'); }, 1200);
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('.pdp-nav__cart-badge').forEach(function (badge) {
          badge.textContent = cart.item_count;
        });
      });
  }

  /* ── Sticky bar visibility ──────────────────────────────────── */
  var stickyBar = document.querySelector('.pdp-sticky');
  if (stickyBar) {
    window.addEventListener('scroll', function () {
      var atcRow = document.querySelector('.pdp-atc-row');
      if (atcRow) {
        var rect = atcRow.getBoundingClientRect();
        stickyBar.classList.toggle('is-visible', rect.bottom < 0);
      }
    }, { passive: true });
  }

  /* ── Supplement facts toggle ────────────────────────────────── */
  document.querySelectorAll('[data-supp-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.closest('.pdp-section').querySelector('.pdp-supp-panel');
      var chevron = btn.querySelector('.pdp-supp-toggle__chevron');
      if (panel) panel.classList.toggle('is-open');
      if (chevron) chevron.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', panel.classList.contains('is-open'));
    });
  });

  /* ── FAQ accordion ──────────────────────────────────────────── */
  document.querySelectorAll('.pdp-faq-item__q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.pdp-faq-item');
      var wasOpen = item.classList.contains('is-open');
      // Close all
      document.querySelectorAll('.pdp-faq-item').forEach(function (fi) { fi.classList.remove('is-open'); });
      // Toggle clicked
      if (!wasOpen) item.classList.add('is-open');
      btn.setAttribute('aria-expanded', !wasOpen);
    });
  });

  /* ── Smooth scroll for anchor links ─────────────────────────── */
  document.querySelectorAll('.pdp-page a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
})();
